import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

export const adminLogin = (params) => {
  return Api(endPoints.login, params, requestType.POST);
};

export const changeAdminPassword = (params) => {
  return Api(endPoints.changePassword, params, requestType.PUT);
};

export const adminForgotPassword = (params) => {
  return Api(endPoints.forgotPassword, params, requestType.POST);
};

export const adminResetPassword = (params) => {
  return Api(endPoints.resetPassword, params, requestType.PUT);
};

export const getDashboardData = () => {
  return Api(endPoints.getDashboardData, requestType.GET);
};

export const getActiveWorkersToday = () => {
  return Api(endPoints.activeWorkersToday, null, requestType.GET);
};
